// Patch window.fetch to always send credentials for API calls
(() => {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  const orig = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const nextInit = { ...init };
    if (!nextInit.credentials) nextInit.credentials = 'include';
    try {
      const token = localStorage.getItem('authToken');
      if (token) {
        nextInit.headers = { ...(nextInit.headers || {}) };
        if (!('Authorization' in nextInit.headers) && !('authorization' in nextInit.headers)) {
          nextInit.headers['Authorization'] = `Bearer ${token}`;
        }
      }
    } catch {}
    const res = await orig(input, nextInit);
    try {
      // Auto-redirect to login on 401s for API calls
      const url = typeof input === 'string' ? input : (input?.url || '');
      const isApi = /\/api\//.test(url);
      if (isApi && res.status === 401) {
        // Only redirect on explicit auth-gating 401s marked by the server
        let reason = '';
        try {
          reason = (res.headers.get('x-auth-reason') || res.headers.get('X-Auth-Reason') || '').toLowerCase();
        } catch {}
        const isAuthGating401 = reason === 'missing-session';
        // Only redirect if we believed we were logged in
        let hadSession = false;
        try { hadSession = !!(localStorage.getItem('authToken') || localStorage.getItem('user')); } catch {}
        if (isAuthGating401 && hadSession && window.location.pathname !== '/' && window.location.pathname !== '/forgot-password') {
          // Clear any persisted user tokens/meta so other contexts won't try to connect
          try {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            localStorage.removeItem('currentUser');
            localStorage.removeItem('chat.agent.open');
            localStorage.removeItem('chat.dm.open');
            localStorage.removeItem('chat.dm.activeUserId');
          } catch {}
          try { window.dispatchEvent(new CustomEvent('auth:logout')); } catch {}
          window.location.assign('/');
        }
      }
    } catch {}
    return res;
  };
})();
